module.exports = __webpack_public_path__ + "img/home-hero-2.efb01ec8.jpeg";